import { render, staticRenderFns } from "./index.html?vue&type=template&id=8aa61cea&"
import script from "./ImportStudentCreditClass.vue?vue&type=script&lang=js&"
export * from "./ImportStudentCreditClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports